import { Component, OnDestroy } from '@angular/core';
import { LayoutService } from '@assetaccountant/core/services/layout.service';

@Component({
  selector: 'app-outage',
  templateUrl: './outage.component.html',
  styleUrls: ['./outage.component.scss'],
  standalone: false,
})
export class OutageComponent implements OnDestroy {
  isOutage = false;

  subsciption = this.layoutService.showOutage.subscribe(outage => {
    this.isOutage = outage;
  });

  constructor(private layoutService: LayoutService) {}

  ngOnDestroy() {
    this.subsciption.unsubscribe();
  }

  refresh() {
    // Need to remove hash
    location.href = location.href.split(/#/)[0];
  }
}
